import moment from 'moment';
import React, { useState } from 'react'
import styled from 'styled-components'

const Table = styled.table`
th {
    cursor: pointer;
}
`;

interface IProps {
    headers:string[]
    data:any[][]
    sortIndex?:number
    cellFormatter?:(columnName:string, cellData:any, rowModel:any) => React.ReactNode
    sortDirection?:string
}



const SortableTable:React.FC<IProps> = (props:IProps) => {
    const [ sortIndex, setSortIndex ] = useState(props.sortIndex || 0);
    const [ sortOrder, setSortOrder ] = useState(props.sortDirection || 'asc');
    
    // const foo:Date = new Date();
    // foo.getTime()
    
    const { headers, data } = props;
    // Create a shallow copy to avoid mutating the parent's data array
    const sortedData = [...data].sort((arr1:any[], arr2:any[]) => {
        if(typeof(arr1[sortIndex]) === 'number'){
            if(sortOrder === 'asc'){
                return arr1[sortIndex] - (arr2[sortIndex]);
            }else{
                return arr2[sortIndex] - (arr1[sortIndex]);
            }

        } else if(typeof(arr1[sortIndex]) === 'string'){
            if(sortOrder === 'asc'){
                return arr1[sortIndex].localeCompare(arr2[sortIndex]);
            }else{
                return arr2[sortIndex].localeCompare(arr1[sortIndex]);
            }
        }else if(arr1[sortIndex] instanceof Date){
            if(sortOrder === 'asc'){
                return arr1[sortIndex].getTime() - arr2[sortIndex].getTime();
            }else{
                return arr2[sortIndex].getTime() - arr1[sortIndex].getTime();
            }
        }
        return 0;
    })
    
    const onHeaderClicked = (index:number) => {
        setSortIndex(index)
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    }

    const defaultCellFormatter = (_columnName:string, cell:any, _rowModel:any): React.ReactNode=>{
        let strVal = cell;
        if(typeof (cell) === 'number'){
            strVal =  (cell as number).toLocaleString();
        }else if(cell instanceof Date){
            strVal = moment(cell).format('D MMM YY')
        }
        return <>{strVal}</>
    }

    return <Table>
        <thead>
            <tr>
                {headers.map((header, i) => <th key={i} onClick={()=>onHeaderClicked(i)}>{header}
                    { sortIndex === i && <>
                    { sortOrder === 'asc' ? <> &#x25B2;</> : <> &#x25BC;</> } 
                    </>}
                    
                </th>)}

            </tr>
        </thead>
        <tbody>
            {sortedData.map((row, index) => {
                return <tr key={index}>
                    {row.slice(0, -1).map((cell, j) => {

                        const formatter = props.cellFormatter || defaultCellFormatter;
                        const columnName = headers[j];
                        const rowModel = row[row.length - 1]; // Last element is the model object
                        const tsx = formatter(columnName, cell, rowModel) || defaultCellFormatter(columnName, cell, rowModel);

                        return <td key={j}>{tsx}</td>
                    })}


                </tr>
            })}

        </tbody>
    </Table>
}

export default SortableTable